export function url(source) {
  return `url("${typeof source === 'string' ? source.replace(/(")/g, '\\$1') : ''}")`;
}

export function px(value) {
  return `${value}px`;
}

export function percent(value) {
  return `${value}%`;
}

export function waitForFontToLoad() {
  return new Promise(function executor(resolve) {
    function check() {
      if (!document.fonts || document.fonts.status === 'loaded') {
        resolve();
      } else {
        setTimeout(check, 500);
      }
    }

    check();
  });
}
